import {FC} from 'react';
import {FontAwesomeIcon, FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import {availableLearnIcons} from "./availableLearnIcons";

type LearnIconProps = Omit<FontAwesomeIconProps,"icon"> & { icon: string }
export const LearnIcon: FC<LearnIconProps> = props => {
  return <FontAwesomeIcon {...props} icon={availableLearnIcons[props.icon] ?? faQuestionCircle} />
}

